/**
 * Resolve Academy API base URL.
 * Production: same-origin `/api` (Render rewrite to backend).
 * Development: REACT_APP_BACKEND_URL or localhost:8001.
 */
export function resolveApiBase() {
  // Production must always use same-origin /api. Render may retain a stale
  // REACT_APP_BACKEND_URL in the build environment; ignore it in production.
  if (process.env.NODE_ENV === "production") {
    return "/api";
  }
  const configured = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
  if (configured) {
    return `${configured}/api`;
  }
  return "/api";
}

export function isSameOriginApi() {
  return resolveApiBase() === "/api";
}
